import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    addFriend, startFollow, stopFollow, acceptFriendRequest,
    cancelFriendRequest, deleteFriend, blockFriend, unblockFriend, seeFriendList,
} from '../../actions/friendsActions'
import {
    reportUser, resetInfo,
} from '../../actions/userActions'
import { getUserInfo, getCountersUserInfo, getRelationBetween } from '../../actions/userActions'

import inMemoryJWT from '../../auth/inMemoryJwt'
import ProfileView from '../../containers/Profile/Profile/Profile';
import { getAdvance } from '../../admin/actions/awardsActions';
import localStorage from '../../utils/hooks/useLocalStorage';


const Profile = ({ getAdvance, history, userRank, routes, match, resetInfo, getUserInfo, isLoadingRelation,
    getRelationBetween, isLoadingGetUserInfo, userInfo, userCounters, getCountersUserInfo, relationBetween, addFriend,
    startFollow, stopFollow, acceptFriendRequest, cancelFriendRequest, deleteFriend }) => {


    let userID = match.params.userID;
    let isNameBig = false;

    const [tap, setTap] = useState('myPost');
  

    useEffect(() => {
        return () => {
            console.log();
            resetInfo()
        }
    }, [])
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {
            getUserInfo(userID, true)
            getAdvance(userID)
            //    seeFriendList()

            if (history.location.pathname.includes('MySaved'))
                setTap("mySaved")
            if (history.location.pathname.includes('MyAwards'))
                setTap("myAwards")
            if (history.location.pathname.includes('MyAlbums'))
                setTap("myAlbums")
            if (history.location.pathname.includes('Marks'))
                setTap("Marks")
        })

    }, [userID])

    useEffect(() => {
        if (userInfo._id) {
            let id = userInfo._id
            if (userInfo.representativeID) {
                if (userInfo.representativeID.state ===2) {
                    id = userInfo.representativeID._id
                }
            }
        
            if (userID !== localStorage().getItem("idProfile")) {
                getRelationBetween(id)
            }
            getCountersUserInfo(id, true)

        }

        return () => {

        }
    }, [userInfo])







    let haveInventory = false;
    let type = "";
    let firstName = "";
    let secondName = "";
    let privateData = [];

    let city = null;
    let department = null;
    let points = 0;
    let isSelf = false;
    let isProfileChanged = false;
    let _idEc = null;

    if (userInfo._id) {
        isSelf = userInfo._id ===localStorage().getItem('idUser');
        isProfileChanged = localStorage().getItem('typeProfile') != "user";
        points = userInfo.rankingScore;
        city = userInfo.ubication?.currentCity;
        department = userInfo.ubication?.currentDepartment;
        firstName = userInfo.name;
        if (userInfo.name.split(' ').length >= 2) {
            isNameBig = true;
        }
        if (userInfo.lastname.split(' ').length >= 2) {
            isNameBig = true;
        }
        secondName = userInfo.lastname

        if (userInfo.privateData) {
            privateData = userInfo.privateData;
        }
    }
    if (userInfo.representativeID) {
        if ((!isSelf && userInfo.representativeID.state ===2) || (isProfileChanged && userInfo.representativeID.state ===2)) {

            haveInventory = true;
            type = "em"
            // firstName = userInfo.representativeID?.socialReason?.split(' ')[0]
            //secondName = userInfo.representativeID?.socialReason?.split(' ')[1]
            city = userInfo.representativeID?.ubication?.businessCity
            department = userInfo.representativeID?.ubication?.businessDepartment
        }
    }
    
 

    if (userInfo.warehouseID) {
        if (!isSelf || isProfileChanged) {
            haveInventory = true;
            type = "wh";
            firstName = userInfo.name

            if (userInfo.name.split(' ').length > 2) {
                firstName = userInfo.name;
                isNameBig = true;
            }
            if (userInfo.lastname.split(' ').length > 2) {
                secondName = userInfo.lastname;
                isNameBig = true;
            }
            else {
                secondName = userInfo.lastname
            }

        }

        //city = userInfo.ubication.currentCity
        // department = userInfo.ubication.currentDepartment
    }


    if (!isLoadingGetUserInfo && userInfo && !userInfo.isEnabled)
        return (<div style={{ width: '100vw', alignItems: 'center', justifyContent: "center", display: 'flex', flexDirection: 'column', height: '80vh' }}>
            Este usuario a eliminado su cuenta
        </div>)

    if (isLoadingGetUserInfo || isLoadingRelation)
        return <div className="cargando"></div>

    const getUserEmail = (user) => {

        if (user.franchiseID) {
            return user.email;
        }
        if (user.representativeID) {
            return user.representativeID.businessEmail;
        }
        else {
            return user.email;
        }
    }

    const getUserPhone = (user) => {
        if (user.franchiseID) {
           
            return user.phone && user.phone;
        }
        if (user.representativeID) {
            return user.representativeID.businessPhone;
        }
        else {
            return user.phone && user.phone;
        }
    }

    return (
        <ProfileView
            isSelf={isSelf}
            routes={routes}
            urlProfile={userInfo.picture && userInfo.picture.url ? userInfo.picture.url.origin : userInfo.picture}
            firstName={firstName}
            secondName={secondName}
            isNameBig={isNameBig}
            privateData={privateData}
            slogan={`"Si no reciclas, reusa. Si no usas, reduce"`}
            followed={userCounters?.countFollowed}
            friends={userCounters?.countFriends}
            followers={userCounters?.countFollowers}
            currentCity={city}
            currentDepartment={department}
            _id={userInfo?._id}
            _idEc={_idEc}
            addFriend={addFriend}
            startFollow={startFollow}
            stopFollow={stopFollow}
            acceptFriendRequest={acceptFriendRequest}
            cancelFriendRequest={cancelFriendRequest}
            deleteFriend={deleteFriend}
            relationBetween={relationBetween}
            userInfo={userInfo}
            haveInventory={haveInventory}
            birthDate={userInfo.birthDate && userInfo.birthDate}
            email={getUserEmail(userInfo)}
            gender={userInfo.gender && userInfo.gender}
            phone={getUserPhone(userInfo)}
            type={type}
            aspiration={userInfo?.aspiration}
            points={points}
            userRank={userRank}

        />
    )
}

const mapStateToProps = (state) => {
    return {
        friendList: state.userInfo.friendList,
        userInfo: state.userInfo.userProfileInfo,
        userCounters: state.userInfo.userProfileCount,
        isUserReported: state.userInfo.reported,
        relationBetween: state.userInfo.relationBetween,
        isLoadingRelation: state.userInfo.isLoadingRelationBetween,
        isLoadingGetUserInfo: state.userInfo.isLoadingGetUserInfo,
        userRank: state.userInfo.userRank
    }
}

export default connect(mapStateToProps, { getCountersUserInfo, getAdvance, seeFriendList, resetInfo, getUserInfo, getRelationBetween, addFriend, startFollow, stopFollow, acceptFriendRequest, cancelFriendRequest, deleteFriend, blockFriend, unblockFriend, reportUser })(Profile)